import Typography from '@mui/material/Typography';
import React from 'react';
import { makeStyles } from '~/tools/makeStyles';
import { COLORS } from '../../../constants/results';

const useStyles = makeStyles(() => ({
  rectContainer: {
    backgroundColor: '#EEEEEE',
    height: '100%',
    width: '100%',
    borderRadius: 4,
  },
}));

export default function RectangleText({ percent, numberOfResponses }) {
  const classes = useStyles();
  return (
    <div className={classes.rectContainer}>
      <div
        style={{
          borderRadius: percent === 100 ? 4 : '4px 0px 0px 4px',
          backgroundColor: COLORS.MAIN,
          height: '100%',
          width: `${percent}%`,
        }}
      >
        <Typography className={classes.ratingNumOfResponsesText}>{numberOfResponses}</Typography>
      </div>
    </div>
  );
}
